<template>
  <div :class="['wrapper', classes]" class="fixed_layout">
    <header class="main-header">
      <span class="logo-mini">
        <span class="img-responsive center-block logo">
          <span class="sidebar-large">Nidin</span>
          <!--<img src="/static/img/matcher_long_logo.png" alt="Logo" class="h-100-p sidebar-large">-->
          <span class="sidebar-mini">N</span>
        </span>
      </span>
      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button" style="height: 50px;">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">
          <ul class="nav navbar-nav">
            <!--連接line@客服-->
            <li>
              <a target="_blank" style="padding-right: 10px;" href="https://line.me/ti/p/~@839wddtv">
                <div>
                  <i class="fa fa-headphones fa-md"></i>
                </div>
              </a>
            </li>
            <!-- Messages-->
            <li :class="['dropdown notifications-menu']">
              <a @click.prevent="openNotifyNews = !openNotifyNews" style="padding-left: 10px;">
                <div>
                  <i class="fa fa-bell-o"></i>
                  <span class="badge badge-bell" v-show="unReadAmount > 0">{{unReadAmount}}</span>
                </div>
              </a>
            </li>

            <li v-if="getRoleType !== 99 && getNidinLeague">
              <a>
                <span class="nd-tooltip">
                  <img src="../assets/icon/nidin_alliance_logo.svg" />
                  <span class="nd-tooltip-text alliance-tooltip">
                    你訂聯盟的品牌可享有 ：系統模組9~8折優惠。一~二則你訂首頁Banner一週的曝光。詳情可洽您的商務窗口。
                  </span>
                </span>
              </a>
            </li>

            <!-- User Account Menu -->
            <li class="dropdown user user-menu">
              <a href="javascript:;" class="dropdown-toggle" data-toggle="dropdown">
                <img src="/static/img/default_user-02.png" class="user-image" alt="User Image">
                <span class="hidden-xs">{{ getAccount }}</span>
              </a>
            </li>
            <li class="dropdown user user-menu" @click="clickLogout">
              <a class="dropdown-toggle" data-toggle="dropdown">
                <span><i class="fa fa-sign-out" aria-hidden="true"></i></span>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :display-name="demo.displayName" :picture-url="demo.avatar" />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <div class="notifyNews" v-if="openNotifyNews">
          <div class="row">
              <div :class="['col-xs-6 nav-tab text-center right-broder cursor-pointer', {'nav-tab-active':!isRead}]" @click.prevent="changeRead(false)">未讀</div>
              <div :class="['col-xs-6 nav-tab text-center cursor-pointer', {'nav-tab-active':isRead}]" @click.prevent="changeRead(true)">已讀</div>
          </div>
          <div class="notifyNewsContent">
            <div class="list-group" v-if="announcementList.length>0">
              <template v-for="(news, index) in announcementList">
                <a @click.prevent="openNews(news)" :key="index" class="list-group-item list-group-item-action cursor-pointer">
                  <div>{{news.title}}</div>
                  <small>{{news.content}}</small>
                  <div><small class="time">系統通知 ｜ {{news.update_time}}</small></div>
                </a>
              </template>

            </div>
            <div v-else class="text-center list-group">
              目前沒有{{isRead?'已讀':'未讀'}}公告
            </div>
          </div>
          <div class="footer text-center" :style="!isRead?'border-top: 1px solid #f4f4f4;':'height:15px'">
            <a v-show="!isRead" class="cursor-pointer"  @click.prevent="markAsRead(null)"><i class="fa fa-check" aria-hidden="true"></i>全部標記為已讀</a>
          </div>
        </div>
        <div v-if="openNotifyNews" class="ful-bg" @click="openNotifyNews = false"></div>
        <div class="title-block">
          <span class="title">{{ $route.meta.title }}</span>
          <span class="subTitle" v-if="$route.meta.subTitle"> -  {{$route.meta.subTitle}}</span>

          <span v-if="$route.meta.docLink" class="pull-right">
            <button class="btn btn-primary" @click="linkDoc">
              <i class="fa fa-info-circle mr-5"></i>開啟操作手冊
            </button>
          </span>
        </div>
        
        
        <!--
        <ol class="breadcrumb" >
          <li v-if="$route.name != 'dashboard' && $route.name != 'brandDashboard'">
            <router-link :to="{path: '/dashboard'}">
              <i class="fa fa-home"></i>首頁
            </router-link>
          </li>
          <li class="c-pointer" v-for="(path, index) in breadcrumb" v-if="breadcrumb[0]" @click="goto(path, index, breadcrumb)">
            {{path}}
          </li>
          <li class="active">
            <i class="fa fa-home" v-if="$route.name == 'dashboard' || $route.name == 'brandDashboard'"></i>
            <i class="fa fa-home" v-if="$route.name == 'dashboard' && $route.name == 'brandDashboard'"></i>&nbsp;&nbsp;{{$route.meta.title}}
          </li>
        </ol>
        -->
      </section>
      <router-view />
      <nd-announcement-overlay
        :dailog-open="dailogOpen"
        :message="message"
        @update:close="close"
      />
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <footer class="main-footer">
      <strong>Copyright &copy; {{year}}
        <a href="javascript:;">Nidin</a>.</strong> All rights reserved.
        <small class="text-current-time data-real-time pull-right">資料來源： {{ currentTime }}</small>
    </footer>
  </div>
  <!-- ./wrapper -->
</template>

<script>
import faker from 'faker'
import { mapGetters, mapActions } from 'vuex'
import Sidebar from './Sidebar.vue'
import NdAnnouncementOverlay from '@/components/elements/nd-announcement-overlay.vue'
import moment from 'moment'
import 'hideseek'
// import $ from 'jquery'

export default {
  name: 'Dash',
  components: {
    Sidebar,
    'nd-announcement-overlay': NdAnnouncementOverlay
  },
  data: function () {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: this.$config.fixedLayout,
        hide_logo: this.$config.hideLogoOnMobile
      },
      error: '',
      bodyH: 0,
      currentTime: '',
      isRead: false,
      unReadAmount: 0,
      announcementList: [],
      dailogOpen: false,
      message: {},
      openNotifyNews: false
    }
  },
  computed: {
    ...mapGetters(['getUserId', 'getAccount', 'getRoleType', 'getUnReadNotify', 'getNidinLeague']),
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    },
    getFile () {
      return this.$parent.getFile
    },
    breadcrumb () {
      var array = this.$route.meta.route.split('/')
      return array
    },
    fixedH () {
      return this.$parent.fixedH
    },
    demo () {
      return {
        displayName: faker.name.findName(),
        avatar: faker.image.avatar(),
        email: faker.internet.email(),
        randomCard: faker.helpers.createCard()
      }
    }
  },
  created () {
    this.getBlackReason()
    this.announcementInfo('open')
  },
  methods: {
    ...mapActions(['clearUserInfo', 'setBlackReason', 'setUnReadNotify']),
    getBlackReason () {
      var self = this
      var url = 'score/shopperBlackReasonList'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var list = response.data.list
          self.setBlackReason(list)
        }
      })
    },
    close () {
      this.dailogOpen = false
      this.markAsRead(this.message.announcement_id)
    },
    changeRead (type) {
      this.isRead = type
      this.announcementInfo('close')
    },
    unReadTotal () {
      const url = 'announcement/online/unReadTotal'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.$store.commit('SET_UNREAD_NOTIFY', response.data.amount)
          this.unReadAmount = response.data.amount
        }
      })
    },
    markAsRead (id = null) {
      let url = 'announcement/online/markAsRead'
      let data = {}
      if (id) {
        data = {
          'announcement_ids': id
        }
      }
      this.getDataH('POST', url, data, (response) => {
        if (response.data.status === 200) {
          this.announcementInfo('open')
        }
      })
    },
    announcementDetail (ID) {
      const url = '/announcement/online/' + ID
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.message = response.data.announcement
        }
      })
    },
    announcementInfo (status, noShowOpen = false) {
      let read = this.isRead ? 1 : 0
      if (status === 'open') {
        read = 0
      }
      const url = '/announcement/online/list?is_read=' + read + '&page=1&size=20'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.announcementList = response.data.announcement_list
          if (status === 'open') {
            const overlayItem = response.data.announcement_list.find(x => x.is_overlay === 1)
            // 新增公告時，不顯示蓋版訊息
            if (overlayItem && !noShowOpen) {
              setTimeout(() => {
                this.openNews(overlayItem)
              }, 500)
            }
          }
          this.unReadTotal()
        }
      })
    },
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    goto (name, index, arr) {
      if (index === arr.length - 1) this.$router.go(-1)
      else {
        if (name === '品牌管理') this.$router.push('/brandTable')
      }
    },
    clickLogout () {
      var url = '/auth/' + this.getUserId + '/logout'
      this.getDataH('post', url, null, (response) => {
        if (response.data.status === 200) {
          this.clearUserInfo()
          this.clearSession()
          this.$router.push('/login')
        }
      })
    },
    clearSession () {
      var allSession = Object.keys(sessionStorage)
      var array = []
      allSession.map(function (c, i, a) {
        array.push(c)
      })
      array.forEach(function (key) {
        sessionStorage.removeItem(key)
      })
    },
    linkDoc () {
      window.open(this.$route.meta.docLink, '_blank')
    },
    openNews (news) {
      this.openNotifyNews = false
      this.dailogOpen = true
      this.announcementDetail(news.announcement_id)
      // this.message = news
    }
  },
  mounted () {
    var self = this
    this.$nextTick(function () {
      self.fixedH()
      self.currentTime = moment().format('MM/DD HH:mm:ss')
    })
  },
  updated () {
    var self = this
    this.$nextTick(function () {
      self.fixedH()
    })
  },
  watch: {
    '$route.path' () {
      this.currentTime = moment().format('MM/DD HH:mm:ss')
    },
    'getUnReadNotify': {
      handler: function (val) {
        this.unReadAmount = val
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.title-block {
  vertical-align: middle;
}
.title {
  font-size: 20px !important;
  font-weight: bold !important;
}
.subTitle{
  font-size: 14px !important;
  bottom: 2px;
}
.text-current-time {
  font-weight: 600 !important;
  font-size: 10px !important;
  bottom: -6px;
}
.content-header>.breadcrumb {
  font-size: 14px;
}
.wrapper.fixed_layout {
  .main-header {
    position: fixed;
    width: 100%;
  }

  .content-wrapper {
    padding-top: 50px;
  }
  @media (max-width: 767px) {
    .content-wrapper {
      padding-top: 100px;
    }
  }
  .main-sidebar {
    position: fixed;
    height: 100vh;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini,
.logo-lg {
  text-align: left;
  img {
    padding: .4em !important;
  }
}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width: 25%;
  }
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}
.sidebar-mini.sidebar-collapse .main-header .sidebar-large, .sidebar-mini .main-header .sidebar-mini{
  display: none;
}
.sidebar-mini.sidebar-collapse .main-header .sidebar-mini{
  display: block;
}
.logo {
  font-weight: 800 !important;
}
.user-image {
  @media (max-width: 767px) {
    top: 3px;
  }
}
.mr-5 {
  margin-right: 5px;
}
.badge-bell{
  background-color: #FF4D4F;
  position: absolute;
  top: -8px;
  left: 10px;
}
.nav-tab{
  padding: 10px 20px;
  border-bottom: 2px solid rgb(244, 244, 244);
}
.right-broder {
  border-right: 1px solid rgb(244, 244, 244);
}
.nav-tab-active {
  border-bottom: 2px solid #3C8DBC;
  color: #3C8DBC;
}
.notifications-open {
  display: block;
}
.time {
  color: #AAA9A9;
}
.notifyNews {
  position: fixed;
  width: 350px;
  z-index: 1000;
  background-color: white;
  box-shadow: 0px 2px 24px rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  margin-left: 10px;
  right: 10px;
}
.notifyNews a{
  color: #000;
}
.notifyNews > .footer {
  line-height: 50px;
}
.notifyNewsContent {
  padding-top: 20px;
  max-height: 200px;
  overflow-y: auto
}
.list-group-item {
  border: none;
}
.ful-bg {
  background: #e1e1e140;
  top: 0;
  left: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 999;
}
.alliance-tooltip {
  text-align: left;
  background-color: #FFF;
  color: #000;
  box-shadow: 0 1px 3px rgba(0,0,0,.12), 0 1px 2px rgba(0,0,0,.24)
}
</style>



// WEBPACK FOOTER //
// Dash.vue?50ff911f